export default __webpack_public_path__ + "static/media/Resume.218755c2.svg";